import { render, staticRenderFns } from "./UpgradeModal.vue?vue&type=template&id=45c5141e&scoped=true"
import script from "./UpgradeModal.vue?vue&type=script&lang=js"
export * from "./UpgradeModal.vue?vue&type=script&lang=js"
import style0 from "./UpgradeModal.vue?vue&type=style&index=0&id=45c5141e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c5141e",
  null
  
)

export default component.exports